import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["responsive", "section", "slug"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { MediaQueryView } from 'marketplace-ui-common/layout/components/MediaQueryView';
import * as ScreenSizes from 'marketplace-ui-common/layout/constants/ScreenSizes';
import { useContext, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useOfferingType } from '../../context/OfferingTypeContext';
import StorefrontUsageTrackerContext from '../../context/StorefrontUsageTrackerContext';
import { getThemeEventSelectorId } from '../../utils/hsAnalytics';
import { getPublicDetailPageFullUrl } from '../../utils/urls';
import { ShareIcon } from 'foundations-assets/icons/components/ShareIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AssetShareButton(_ref) {
  let {
      responsive,
      section,
      slug: passedSlug
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    slug
  } = useParams();
  const shareSlug = passedSlug || slug;
  const {
    trackDetailsInteraction
  } = useContext(StorefrontUsageTrackerContext);
  const lang = getLang();
  const offeringType = useOfferingType();
  const {
    isMobileView
  } = useResponsiveProps({
    isMobileView: {
      [ScreenSizes.XS]: true,
      [ScreenSizes.MD]: false
    }
  });
  const computedShareUrl = useMemo(() => {
    return getPublicDetailPageFullUrl(lang, offeringType, shareSlug);
  }, [lang, offeringType, shareSlug]);
  return /*#__PURE__*/_jsxs(CopyButton, Object.assign({}, rest, {
    marginInlineStart: "300",
    onClick: () => trackDetailsInteraction('click share link', {
      section
    }),
    "data-test-id": "asset-share-button",
    "data-hs-analytics-id": getThemeEventSelectorId('SHARE'),
    value: computedShareUrl,
    children: [/*#__PURE__*/_jsx(ShareIcon, {
      size: responsive && isMobileView ? '600' : undefined
    }), /*#__PURE__*/_jsx(MediaQueryView, {
      min: responsive ? 'md' : 'xs',
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.details.share"
      })
    })]
  }));
}